import { IPermission, IPermissionAppsList } from '../apps/apps.types';

export interface IRole {
  businessId: number;
  key: string;
  roleName: string;
  tag: string;
  id?: number;
}

export interface ICreateRoleRequest {
  roles: IRole;
  permissionData: IPermissionAppsList;
}

export interface RoleList {
  createdAt?: string;
  createdBy?: string | null;
  deletedAt?: string | null;
  deletedBy?: string | null;
  id: number;
  key: string;
  noOfEmployee?: number;
  roleName: string;
  status: string;
  tag: string[];
  updatedAt?: string;
  updatedBy?: string | null;
}

export interface IGetRoleResponse {
  role: RoleList[];
  webDashPermissions: IPermission[];
  mPosPermissions: IPermission[];
  posPermissions: IPermission[];
  momPermissions: IPermission[];
}

export enum InternalRoles {
  AIO_BUDDY = 'aio-buddy',
  SUPER_ADMIN = 'super-admin',
  OPERATION = 'operation',
}
export interface IGetRoleByIdResponse {
  role: RoleList[];
  webDashPermissions: IPermission[];
  mPosPermissions: IPermission[];
  posPermissions: IPermission[];
  momPermissions: IPermission[];
}
